module.exports = __webpack_public_path__ + "img/play-btn.a11cce99.svg";